import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import InstallMobileIcon from "@mui/icons-material/InstallMobile";

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [open, setOpen] = useState(false);
  const [showManualInstructions, setShowManualInstructions] = useState(false);

  useEffect(() => {
    const dontShowAgain = localStorage.getItem("pwaInstallDismissed");
    if (dontShowAgain) {
      console.log("Usuário escolheu não mostrar o modal novamente.");
      return;
    }

    console.log("Verificando se o evento beforeinstallprompt será disparado...");

    const handleBeforeInstallPrompt = (event) => {
      event.preventDefault();
      console.log("Evento beforeinstallprompt capturado! Exibindo modal...");
      setDeferredPrompt(event);
      setOpen(true);
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  useEffect(() => {
    if (window.matchMedia("(display-mode: standalone)").matches) {
      console.log("PWA já está instalado, ocultando popup.");
      setOpen(false);
    }
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      console.log("O evento beforeinstallprompt não está disponível. Exibindo instruções manuais.");
      setShowManualInstructions(true);
      return;
    }
    deferredPrompt.prompt();
    const choiceResult = await deferredPrompt.userChoice;
    if (choiceResult.outcome === "accepted") {
      console.log("Usuário aceitou instalar o PWA.");
    } else {
      console.log("Usuário recusou a instalação do PWA.");
    }
    setDeferredPrompt(null);
    setOpen(false);
  };

  const handleDismissForever = () => {
    localStorage.setItem("pwaInstallDismissed", "true");
    setOpen(false);
    console.log("Usuário escolheu não mostrar o aviso novamente.");
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
        📲 Instale este site como um APP!
      </DialogTitle>
      <DialogContent>
        {!showManualInstructions ? (
          <>
            <Typography variant="body1" align="center" sx={{ mb: 2 }}>
              Aproveite a experiência completa deste site diretamente no seu celular ou computador!
            </Typography>
            <Typography variant="body2" align="center" sx={{ color: "gray" }}>
              O site funcionará como um aplicativo nativo, sem precisar de instalação pela Play Store!
            </Typography>
          </>
        ) : (
          <>
            <Typography variant="h6" align="center" sx={{ mb: 2 }}>
              Como instalar manualmente no celular:
            </Typography>
            <Typography variant="body2" sx={{ mb: 1 }}>
              🔹 **Android (Chrome)**:  
              1. Toque nos **três pontinhos** no canto superior direito.  
              2. Escolha **"Adicionar à tela inicial"**.  
              3. Confirme e pronto!
            </Typography>
            <Typography variant="body2">
              🔹 **iPhone (Safari)**:  
              1. Toque no botão de **Compartilhar** (ícone de quadrado com seta).  
              2. Escolha **"Adicionar à Tela de Início"**.  
              3. Confirme e pronto!
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
        {!showManualInstructions ? (
          <Button
            variant="contained"
            color="primary"
            startIcon={<InstallMobileIcon />}
            onClick={handleInstallClick}
            sx={{ px: 4, py: 1.5, fontSize: "1rem", fontWeight: "bold" }}
          >
            Instalar agora
          </Button>
        ) : null}
        <Button onClick={() => setOpen(false)} color="secondary">
          Fechar
        </Button>
        <Button onClick={handleDismissForever} color="error">
          Não mostrar novamente
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PWAInstallPrompt;
